// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"7938b1e2","92":"0b79c605","178":"312b0538","317":"7bebfe95","453":"8701dc61","551":"c7783327","615":"1cc7bd09","787":"8d60f6ef","822":"82ed3345","840":"670e32e0","887":"b13857f7","889":"45142978","920":"5db711d2"}[chunkId] + ".chunk.js";
};